import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import {Dimmer} from "../spinner";
import useTable from "../useTable";
import Controls from "../controls/Controls";

import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import {
  validaMonto,
  formatoMonto,
  validaSoloNumero,
  formatMoneda,
} from "../../util/varios";
import moment from "moment";
import useTableFijo from "../useTableFijo";
import AgregarTipoConstruccion from "./agregarValorTipoConstruccion";

const ModalAgregarFactura = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPOLOGIA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AREA(M2)",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR PTR(M2)",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "% PLUSVALIA",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR ACTUAL(PTR)",
      textAlign: "center",
    },
  ];

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1);

  /*  variables de estados */

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
  const idusuario = JSON.parse(localStorage.getItem('idusuario'));

  const txtFecha = useRef();
  const txtDescrip = useRef();
  const txtValorPrivado = useRef();
  const btnCancela = useRef();
  const txtSector = useRef();
  const txtApendice = useRef();
  const txtValorMuni = useRef();
  const txtTipoImpuesto = useRef();
  const txtNumFact = useRef();
  const txtMonto = useRef();


  const [records, setRecords] = useState([]);
  const [mostrar, setMostrar] = useState(false);
  const [labels, setLabels] = useState("Bs/m2");
  const [titulo, setTitulo] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idvalorterreno: "",
    apendice: "",
    sector: "",
    descripcion: "",
    valor: "",
    valorpriv: "",
    rural: 0,
  });
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState("0");
  const [valorPetro, setValorPetro] = useState();
  const [operacionFicha, setOperacionFicha] = useState("0");

  const blanquear = () => {
    setValues({
      idvalorterreno: "",
      apendice: "",
      sector: "",
      descripcion: "",
      valor: "",
      valorpriv: "",
      rural: 0,
    });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };

  const cancelar = () => {
    setActivate(false)
    props.onHideCancela();

    /*  blanquear() */
  };

  const seleccionarFactura = (uso) => {
    let campos = "fc.*,f.descripcion";
    let nomtab = "facturascredito as fc, factura as f";
    let nomid = "fc.numerofactura";
    let nomid2 = 'f.numfactura';

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${uso}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${uso}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data[0]);
          txtNumFact.current.value = response.data[0].numerofactura;
          txtTipoImpuesto.current.value = "INMUEBLE";
          txtDescrip.current.value = response.data[0].descripcion;

          txtFecha.current.value = moment.utc(response.data[0].fechaasignacion).format('YYYY-MM-DD');
          txtMonto.current.value = response.data[0].monto ? formatMoneda(response.data[0].monto.toString().replace(".", ","), ",", ".", 2) : '0,00'
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const procesarFactura = () => {
    let endpoint = `${op.conexion}/api/catastro/insertfactura`;
    let body;
    setActivate(true);

    body = {
      numfact: txtNumFact.current.value.trim(),
      fecha: fechasistema,
      iduser: idusuario,
      idcontri: props.inmueble ? props.inmueble.idinmueble : '',
      impuesto: 'inmueble',
      monto: txtMonto.current.value.replace(/\./g, "").replace(",", ".")
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Datos Registrado Exitosamente",
            icono: "exito",
          });

        }
        setActivate(false);

        props.onHideRender(props.inmueble.idinmueble);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const procesarFacturaDelete = () => {
    let endpoint = `${op.conexion}/api/catastro/deletefacturacredi`;
    let body;
    setActivate(true);

    body = {
      numfact: txtNumFact.current.value.trim(),
      idcontri:props.inmueble ? props.inmueble.idinmueble : '',
      monto: txtMonto.current.value.replace(/\./g, "").replace(",", ".")
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Datos Registrado Exitosamente",
            icono: "exito",
          });

        }
        setActivate(false);
        props.onHideRender(props.inmueble.idinmueble);

      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    if (operacion === 1) {
      if (txtNumFact.current.value !== "") {
        let campos = "*";
        let id = txtNumFact.current.value;
        let nomtab = "facturascredito";
        let nomid = "numerofactura";
        let condic = "impuesto = 'inmueble'";

        let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
        console.log(endpoint);
        setActivate(true);

        axios
          .get(endpoint, {
            headers: {
              "x-access-token": `${token}`,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              console.log(response.data)
              if (response.data.length === 0) {
                procesarFactura()
                console.log('si proceso')
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación.",
                  texto: "La factura" + txtNumFact.current.value + ' ya fue incluida como crédito físcal',
                  icono: "informacion",
                });
              }
              setActivate(false);
            }
          })
          .catch((error) => {
            setMensaje({
              mostrar: true,
              titulo: "ERROR",
              texto: error.response.data.message,
              icono: "error",
            });

            setActivate(false);
          });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "Debe ingresar el numero de factura",
          icono: "informacion",
        });
        txtNumFact.current.focus()
      }
    } else{
      procesarFacturaDelete()
    }
  };

  const datosFactura = (id) => {
    let campos = "*";
    let nomtab = "factura";
    let nomid = "numfactura";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            console.log(response.data);
            setValues(response.data);
            txtDescrip.current.value = response.data.descripcion;
            txtFecha.current.value = moment.utc(fechasistema).format('YYYY-MM-DD')
            txtTipoImpuesto.current.value = "INMUEBLE";
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación.",
              texto: "No existe una Factura con este numero",
              icono: "informacion",
            });
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const validarFact = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosFactura(event.target.value);
      } else {
        setValues("");
        txtTipoImpuesto.current.value = "";
      }
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        console.log(props.operacion);

        if (props.operacion !== 1) {
          seleccionarFactura(props.numfac)

        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>Gestion de Facturas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AgregarTipoConstruccion
          show={mostrar}
          onHideCancela={() => {
            setMostrar(false);
          }}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <Dimmer active={activate} inverted>
          
        </Dimmer>

        <div className="col-md-12 row mx-auto border-azul rounded py-2 px-0">
          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              N° Factura:
            </span>
            <input
              type="text"
              ref={txtNumFact}
              className="form-control text-uppercase"
              disabled={operacion === 3 ? true : false}
              onKeyUp={validarFact}
              onBlur={validarFact}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-7">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Fecha Asignación:
            </span>
            <input
              disabled
              type="date"
              className="form-control text-uppercase"
              ref={txtFecha}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"

            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-12">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Contribuyente:
            </span>
            <input
              disabled
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={values ? values.nombrecontri : ""}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-6">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Monto de Factura:
            </span>
            <input
              type="text"
              disabled
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              ref={txtMonto}
              value={
                values
                  ? formatMoneda(
                    (
                      parseFloat(values.totalinmpuesto) +
                      parseFloat(values.totalrecargo) +
                      parseFloat(values.totalinteres)
                    )
                      .toString()
                      .replace(".", ","),
                    ",",
                    ".",
                    2
                  )
                  : ""
              }
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-6">
            <span className="input-group-text " id="inputGroup-sizing-sm">
              Tipo de Impuesto:
            </span>
            <input
              type="text"
              disabled
              ref={txtTipoImpuesto}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-12">
            <span className="input-group-text " id="inputGroup-sizing-sm">
              Concepto
            </span>
            <textarea
              type="textarea"
              disabled
              style={{ height: 60 }}
              ref={txtDescrip}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAgregarFactura;
